import api from './api';
import { getAttribution } from '../utils/attribution';

export async function login(email, password) {
  const form = new URLSearchParams();
  form.append('username', email);
  form.append('password', password);
  const res = await api.post('/api/auth/login', form, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  return res.data;
}

// Seconde étape du login quand le compte a la 2FA active.
// Le cookie vx_2fa_pending (HttpOnly, path=/api/auth/2fa, TTL 5 min) est posé par
// /api/auth/login et renvoyé automatiquement ici grâce à withCredentials.
// Le header X-CSRF-Token est ajouté par l'intercepteur de services/api.js.
export async function verify2fa(code) {
  const res = await api.post('/api/auth/2fa/verify', { code });
  return res.data;
}

export async function register(email, password, refCode, profil, consentementEmail = false) {
  const res = await api.post('/api/auth/register', {
    email,
    password,
    ref_code: refCode || null,
    profil: profil || null,
    // Case NON pré-cochée de l'inscription : seul un oui explicite est tracé.
    consentement_email: Boolean(consentementEmail),
    // Origine mémorisée à la première arrivée (30 j). Null si le visiteur est
    // venu en direct ou si son navigateur refuse le stockage local — le
    // backend l'ignore alors sans faire échouer l'inscription.
    attribution: getAttribution(),
  });
  return res.data;
}

export async function getMe() {
  const res = await api.get('/api/auth/me');
  return res.data;
}

export async function completeOnboarding(profileType) {
  const res = await api.post('/api/auth/onboarding', { profile_type: profileType });
  return res.data;
}

export async function logout() {
  try {
    await api.post('/api/auth/logout');
  } catch (_) {}
  localStorage.removeItem('zenkart_token');
  localStorage.removeItem('zenkart_user');
}
